import axios from "axios";
import querystring from "query-string";

export const exchangeCodeForAccess = async code => {
  const config = {
    headers: {
      accept: "application/json",
      "cache-control": "no-cache",
      "content-type": "application/x-www-form-urlencoded"
    }
  };
  const data = {
    grant_type: "authorization_code",
    client_id: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirect_uri: `${window.location.protocol}${process.env.REACT_APP_URL}/implicit/callback`,
    code: code,
    code_verifier: "M25iVXpKU3puUjFaYWg3T1NDTDQtcW1ROUY5YXlwalNoc0hhakxifmZHag"
  };

  try {
    const access = await axios.post(
      `${process.env.REACT_APP_OKTA_ORG_URL}/oauth2/v1/token`,
      querystring.stringify(data),
      config
    );
    return { data: access.data, success: true };
  } catch (error) {
    return { data: error, success: false };
  }
};

export const validateUser = async () => {
  const config = {
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${getAccessToken()}`
    }
  };
  const access = await axios.get(
    `${process.env.REACT_APP_API_HOST}identity/api/user/validate`,
    config
  );
  if (access.data.isError) {
    window.location = "/equipmentfinder/login";
  }
  return access.data;
};

export const saveAccessToken = accessToken => {
  try {
    window.localStorage.setItem("accessToken", accessToken);
    return true;
  } catch (e) {
    return false;
  }
};

export const deleteAccessToken = () => {
  try {
    window.localStorage.removeItem("accessToken");
    return true;
  } catch (e) {
    return false;
  }
};

export const getAccessToken = () => {
  try {
    const accessToken = window.localStorage.getItem("accessToken");
    return accessToken;
  } catch (e) {
    return false;
  }
};

export const handleStatusError = statusCode => {
  switch (statusCode) {
    case 401:
      deleteAccessToken();
      redirectURLParams();
      window.location = `/equipmentfinder/login?autoLogin=1`;
      break;
    default:
      break;
  }
};

export const saveRedirectPath = redirectPath => {
  try {
    window.localStorage.setItem("redirectPath", redirectPath);
  } catch (e) {}
};

export const getRedirectPath = () =>
  window.localStorage.getItem("redirectPath");

export const deleteRedirectPath = () => {
  window.localStorage.removeItem("redirectPath");
};

export const redirectURLParams = () => {
  let { href, pathname } = window.location;
  pathname = pathname.split("/")[2];
  if (pathname === "login") {
    return;
  }
  saveRedirectPath(`${href}`);
};
